<template>
  <div>
    <div class="text-xs-center mt-4 mb-4" v-if="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else-if="user">
      <template v-if="['ticket'].includes(theme)">
        <ticket-customer-detail v-model="user.id" :pageid="pageid">
          <div slot="header">&nbsp;</div>
        </ticket-customer-detail>
      </template>
      <template v-else>
        <customer-detail :pageid="pageid" v-model="user" :getuseronly="true" :loaduser="false">
          <div slot="header">&nbsp;</div>
        </customer-detail>
      </template>
    </div>
    <div v-else>
      <div class="text-xs-center mt-4 mb-4">
        <v-icon x-large>error_outline</v-icon>
        <p>No detail</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import CustomerDetail from '@/components/view/dashboard/CustomerDetail.vue'
import TicketCustomerDetail from '@/components/view/dashboard/TicketCustomerDetail.vue'
export default {
  props: ['value', 'pageid', 'theme'],
  components: {
    CustomerDetail,
    TicketCustomerDetail
  },
  data: function() {
    return {
      loading: true,
      user: undefined,
      chatboxHeight: 0,
      session: '',
      assignadminname: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted: function() {
    var vm = this

    vm.loading = true

    vm.getUser(vm.value.userid).then(
      function(user) {
        if (user) {
          vm.user = user
          vm.session = user.session ? user.session : ''
          vm.assignadminname = user.adminname
        }
        vm.loading = false
      },
      function(error) {
        vm.loading = false
      }
    )
  },
  methods: {
    changeAsssign(value) {
      var vm = this
      var data = {
        params: {
          pageid: vm.$store.state.livechat.pageid
        },
        body: {
          usersid: this.user.id,
          adminname: value
        }
      }
      api.saveuseradminname(data, (error, response) => {
        if (error) {
          // reject(error)
        }
      })
    },
    changeSession(value) {
      var vm = this
      var data = {
        params: {
          pageid: vm.$store.state.livechat.pageid
        },
        body: {
          usersid: this.user.id,
          session: value
        }
      }
      api.saveusersession(data, (error, response) => {
        if (error) {
          // reject(error)
        }
      })
    },
    onResizeChatbox: function() {
      var vm = this
      setTimeout(() => {
        vm.chatboxHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - 5
        if (document.getElementById('chatinput')) {
          vm.chatinputHeight = document.getElementById('chatinput').clientHeight
        }
      }, 500)
    },
    getUser: function(userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.$store.state.livechat.pageid
        }
        api.getUserOnly(data, function(error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data[0])
          } else {
            resolve(undefined)
          }
        })
      })
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      var vm = this

      if (newVal == null) {
        vm.user = undefined
      } else if (newVal.id != oldVal.id) {
        vm.loading = true

        vm.getUser(newVal.userid).then(
          function(user) {
            if (user) {
              vm.user = user
            }
            vm.loading = false
          },
          function(error) {
            vm.loading = false
          }
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-customers.vue